// Страницы документации «Бонусы» API интеграций (main IntegrationController, сервис лояльности).
// Все методы — с заголовком uuid компании и Basic-авторизацией (раздел «Интеграции внешних систем»).
import type { ApiDocBlock, ApiDocPage } from '../types'

const common: ApiDocBlock = {
  id: 'errors',
  heading: 'Ошибки',
  text: [
    ':customer_id — id покупателя в нашей системе (из ответа POST /api/integration/v1/customers).',
    '400 «Программа лояльности не активирована» — у компании выключена бонусная программа; запрос в сервис бонусов не уходит.',
    '404 «Не найдено» — покупателя с таким id нет.',
    '401 «Unauthenticated» — неверные логин и пароль Basic или uuid компании.',
  ],
  code: `{
  "success": 0,
  "data": null,
  "error": "Программа лояльности не активирована"
}`,
}

const writeErrors: ApiDocBlock = {
  id: 'write-errors',
  heading: 'Если ответ не пришёл',
  text: [
    'Начисление и списание не повторяются автоматически. Ответ 504 «Сервис бонусов не ответил» значит, что операция могла пройти: проверьте баланс, прежде чем повторять запрос, иначе бонусы начислятся или спишутся дважды.',
    'Ошибка формата (amount не передан, не число или меньше 1) — 422, в error.message и error.errors.',
  ],
}

const params = `{
  "amount": 100,     // обязательно, целое, не меньше 1
  "comment": "test"  // не обязательно, видно в истории бонусов покупателя
}`

export const bonusApiDocs: Record<string, ApiDocPage> = {
  bonusBalance: {
    link: ['GET /api/integration/v1/bonus/:customer_id/balance'],
    blocks: [
      {
        id: 'success',
        heading: 'Пример ответа',
        text: ['В data — число доступных бонусов.'],
        code: `{
  "success": 1,
  "data": 129,
  "error": null
}`,
      },
      common,
    ],
  },
  bonusInfo: {
    link: ['GET /api/integration/v1/bonus/:customer_id/info'],
    blocks: [
      {
        id: 'success',
        heading: 'Пример ответа',
        text: [
          'purchases — сумма покупок, по которой считается уровень; balance — доступные бонусы.',
          'expiration — ближайшее сгорание: null или { "amount": число бонусов, "date": "ГГГГ-ММ-ДД" }.',
          'levels.current — текущий уровень, levels.next — следующий (null на верхнем уровне). percent — процент начисления, buy_percent — какую часть покупки можно оплатить бонусами; оба могут быть дробными.',
          'settings — правила начисления компании: не начислять на покупку, оплаченную бонусами, и на сумму, оплаченную бонусами.',
        ],
        code: `{
  "success": 1,
  "data": {
    "purchases": 8498,
    "balance": 129,
    "expiration": { "amount": 50, "date": "2026-12-31" },
    "levels": {
      "current": {
        "id": 2,
        "name": "Надбазовый",
        "threshold": 5000,
        "bonus_expiration_days": 0,
        "percent": 7,
        "buy_percent": 50
      },
      "next": {
        "id": 3,
        "name": "Сверхбазовый",
        "threshold": 10000,
        "bonus_expiration_days": 100,
        "percent": 13,
        "buy_percent": 50
      }
    },
    "settings": {
      "dont_add_when_paid_with_bonus": 0,
      "dont_add_for_bonuses": 1
    }
  },
  "error": null
}`,
      },
      common,
    ],
  },
  bonusAdd: {
    link: ['POST /api/integration/v1/bonus/:customer_id/add'],
    blocks: [
      {
        id: 'params',
        heading: 'Параметры',
        text: ['Без комментария в истории будет «Ручное добавление».'],
        code: params,
      },
      {
        id: 'success',
        heading: 'Пример ответа',
        code: `{
  "success": 1,
  "data": 1,
  "error": null
}`,
      },
      writeErrors,
      common,
    ],
  },
  bonusSub: {
    link: ['POST /api/integration/v1/bonus/:customer_id/sub'],
    blocks: [
      {
        id: 'params',
        heading: 'Параметры',
        text: ['Без комментария в истории будет «Списание бонусов».'],
        code: params,
      },
      {
        id: 'success',
        heading: 'Пример ответа',
        code: `{
  "success": 1,
  "data": 1,
  "error": null
}`,
      },
      {
        id: 'shortage',
        heading: 'Если бонусов не хватает',
        text: ['Ничего не списывается, ответ 422 с балансом и запрошенной суммой.'],
        code: `{
  "success": 0,
  "data": null,
  "error": { "message": "Недостаточно бонусов: на счёте 100, списать нужно 150" }
}`,
      },
      writeErrors,
      common,
    ],
  },
}
